// * Composes Path For Requests
let requestType, urlDomain, db;

requestType = "https";
urlDomain = window.location.host;

// * Configure Database
const possibleDomains = ["cpemanager.xyvid.com", "cpeoverride.xyvid.com"];
if (possibleDomains.includes(urlDomain)) {
    //~ If Possible Domains Include The Current Domain
    db = 6;
} else {
    //~ Determine Database Dynamically
    const subdomain = window.location.hostname.split(".")[0];
    const prefaceString = "cpemanager";

    db = subdomain.slice(prefaceString.length); // cpemanager12 => 12
}

// * If In Dev - Change Domain, Request Type, And Database
const inDev = document.domain === "localhost";
if (inDev) {
    requestType = "http";
    urlDomain = "localhost:21332";
    db = 12;
}

// * Compose The Path And Export Variables
const urlApi = `${requestType}://${urlDomain}`;

const ApiPath = { urlApi, db };

export default ApiPath;
